import React from "react";
var __jsx = React.createElement;
var PreCheckoutOptionsShimmer = function PreCheckoutOptionsShimmer() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "space-y-6 animate-pulse"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rounded-lg  p-4 shadow-sm bg-white border border-solid border-gray-azureish"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-20 w-28 rounded-md bg-gray-200"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 space-y-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-4 w-2/3 rounded bg-gray-200"
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-3 w-1/2 rounded bg-gray-200"
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-3 w-1/3 rounded bg-gray-200"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "mt-4 h-10 w-32 rounded-md bg-gray-200"
  })), /*#__PURE__*/React.createElement("div", {
    className: "rounded-lg  p-4 shadow-sm bg-white border border-solid border-gray-azureish"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-16 w-16 rounded-full bg-gray-200"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 space-y-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-4 w-1/2 rounded bg-gray-200"
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-3 w-2/3 rounded bg-gray-200"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "mt-4 h-10 w-32 rounded-md bg-gray-200"
  })))));
};
export default PreCheckoutOptionsShimmer;